<template>
<div class="container">
  <div class="long-relation hidden2" v-infocus="'showLongRelation'">
    <div class="colored-overlay"></div>
    <slot></slot>
  </div>
</div>
</template>

<script>
export default {
  name: 'fullBanner',
  directives: {
    infocus: {
      isLiteral: true,
      inserted: (el, binding, vnode) => {
        let f = () => {
          let rect = el.getBoundingClientRect()
          let inView = (
            rect.width > 0 &&
            rect.height > 0 &&
            rect.top >= 0 &&
            rect.bottom <= (window.innerHeight || document.documentElement.clientHeight)
          )
          if (inView) {
            el.classList.add(binding.value)
            window.removeEventListener('scroll', f)
          }
        }
        window.addEventListener('scroll', f)
        f()
      }
    }
   },
}
</script>

<style lang="scss" scoped>
.long-relation{
  position: relative;
  min-height: 400px;
  border-radius: 10px;
  // background: url(../../assets/Folded_Paper_client_picture.jpg);
  background-repeat: no-repeat;
  background-size: cover;
  width: 100%;
  @include transition;
  margin: 0 auto;
  margin-bottom: layout-val-8(18);
  transition-delay: 1s;

    h4{
      z-index: 1;
      @include pos-center($axis: 'both');
      text-align: center;
      opacity: 0;
    }
    
    .colored-overlay{
      position:absolute;
      top:0;
      left: 0;
      background-color: $white;
      opacity: 0.8;
      height: 100%;
      width: 100%;
    }
}

@media screen and (max-width: 800px) {
  .long-relation{
    min-height: 250px;
  }
}
</style>